<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import StockModal from "@/components/modals/stock-modal.vue";
import StockTransactionModal from "@/components/modals/stock-transaction-modal.vue";
import StockLedger from "@/components/widgets/stock-ledger.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import UploadStock from "@/components/modals/upload-stock.vue";
import RawData from "@/components/widgets/raw-data.vue";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Stocks"
  },
  components: {
    Layout,
    PageHeader,
    StockModal,
    StockTransactionModal,
    StockLedger,
    UploadStock,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Stocks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Stocks",
          active: true
        }
      ],
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterTrans: "",
      filterOn: [],
      maxCredit: 0,
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "select",
          label: "",
          thStyle: { width: "50px" }
        },
        {
          key: "stockNumber",
          sortable: true,
          label: "Stock Number"
        },
        {
          key: "name",
          sortable: true,
          label: "Stock Name"
        },
        {
          key: "itemCategory",
          sortable: true,
          label: "Category"
        },
        {
          key: "unit",
          sortable: false,
          label: "Unit"
        },
        {
          key: "unitCost",
          sortable: false,
          label: "Unit Cost",
          thStyle: { width: "150px", textAlign: "center" },
          tdClass: "text-center v-align-middle"
        },
        {
          key: "available",
          sortable: false,
          label: "Current Balance",
          thStyle: { width: "150px" },
          tdClass: "text-center v-align-middle"
        },
        {
          key: "actions",
          sortable: false,
          label: "Actions",
          thStyle: { width: "200px" },
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      fieldsTrans: [
        {
          key: "referenceNo",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "description",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "300px" }
        },
        {
          key: "quantity",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "350px" }
        },
        {
          key: "status",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "100px" }
        },
        {
          key: "actions",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "70px" }
        }
      ],
      statusOptions: ["APPROVED", "PENDING"],
      tableBusy: false,
      editMode: false,
      unit: "",
      itemCategory: "",
      transaction: null,
      cycle: this.$store.state.data.cycle,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Transaction",
        placement: "lefttop",
        folder: "Stocks"
      },
      uploadType: "",
      selectedStock: null,
      selectedTransaction: null,
      transactionType: 0,
      itemIndex: -1,
      selectAll: false,
      itemCategories: [],
      units: [],
      deliveryUnits: [],
      ledgerStock: null,
      ledgerTransactions: [],
      ledgerLoading: false,
      errorData: "",
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          const searchTerm = this.filter.toUpperCase();
          return (
            item.name.toUpperCase().includes(searchTerm) ||
            item.stockNumber.toUpperCase().includes(searchTerm) ||
            item.description.toUpperCase().includes(searchTerm) ||
            item.itemCategory.toUpperCase().includes(searchTerm)
          );
        });
      }
      return data;
    },
    rows() {
      return this.filtered.length;
    },
    selectedItems() {
      return this.tableData.filter(item => item.selected);
    },
    hasSelectedItems() {
      return this.selectedItems.length > 0;
    },
    isAllSelected() {
      return this.tableData.length > 0 && this.selectedItems.length === this.tableData.length;
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus.id);
  },
  methods: {
    async changeCampus(id) {
      this.tableBusy = true;
      await this.getStock(id);
      this.tableBusy = false;
      this.getDeliveryUnits(id);
    },
    async getDeliveryUnits(id){
      await this.$store
        .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.deliveryUnits = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting stock list!", "error");
        });
    },
    async getStock(id) {
      await this.$store
        .dispatch("stock/GetStocks", id)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.filterPrice = "";
            item.filter = "";
            item.visible = false;
            item.transactionLoading = false;
            item.transactions = [];
            item.selected = false;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting stock list!", "error");
        });
    },

    addStock() {
      this.modalTitle = "Create Stock";
      this.$refs.stockModal.resetForm();
      this.$bvModal.show("stock-modal");
    },

    async submitStock(modalData) {
      modalData.campusId = this.$store.state.data.selectedCampus.id;
      try {
        if (modalData.id > 0) {
          const res = await this.$store.dispatch("stock/UpdateStock", modalData);
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          const index = this.tableData.findIndex(item => item.id === modalData.id);
          if (index !== -1) {
            this.tableData.splice(index, 1, {
              ...modalData,
              selected: false,
            });
          }
          this.showToast("Stock updated successfully", "success");
        } else {
          const res = await this.$store.dispatch("stock/CreateStock", modalData);
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.tableData.push({
            ...res.data,
            selected: false,
          });
          this.showToast("Stock created successfully", "success");
        }
        this.$bvModal.hide("stock-modal");
        this.$refs.stockModal.isSubmitting = false;
      } catch (error) {
        this.showToast("Failed to save stock", "error");
        this.$refs.stockModal.isSubmitting = false;
      }
    },

    updateItem(props) {
      this.modalTitle = "Update Stock";
      this.$refs.stockModal.updateData(props);
      this.$bvModal.show("stock-modal");
    },

    deleteItem(props) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStock", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              
              const index = this.tableData.findIndex(i => i.id === props.id);
              if (index !== -1) {
                this.tableData.splice(index, 1);
              }
              this.showToast("Stock deleted successfully", "success");
            })
            .catch(() => {
              this.showToast("Failed to delete stock", "error");
            });
        }
      });
    },

    deleteSelectedItems() {
      if (this.hasSelectedItems) {
        Swal.fire({
          title: "Are you sure?",
          text: `You are about to delete ${this.selectedItems.length} stock(s). You won't be able to revert this!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, delete them!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.pageLoader(true);
            for await (const x of this.selectedItems) {
              await this.$store
                .dispatch("stock/DeleteStock", x.id)
                .then((res) => {
                  this.tableData.splice(
                    this.tableData.findIndex((i) => i.id == x.id),
                    1
                  );
                })
                .catch((err) => {
                  this.showToast("Cannot be deleted!", "error");
                });
            }
            this.pageLoader(false);
            this.showToast("Successfully deleted", "success");
            this.selectAll = false;
          }
        });
      } else {
        this.showToast("No items selected!", "warning");
      }
    },
    async submitTransaction(modalData) {
      modalData.stockItemId = this.selectedStock.id;
      try {
        if (modalData.id > 0) {
          const res = await this.$store.dispatch("stock/UpdateStockTransaction", modalData);
          
          if (res.data.error) {
            this.showToast(res.data.errorMessage, "error");
            return;
          }
          
          this.showToast("Transaction updated successfully", "success");
        } else {
          const res = await this.$store.dispatch("stock/CreateStockTransaction", modalData);
          
          if (res.data.error) {
            this.showToast(res.data.errorMessage, "error");
            return;
          }
          
          this.showToast("Transaction created successfully", "success");
        }
        this.showStockLedger(this.selectedStock);
        this.$bvModal.hide("stock-transaction-modal");
        this.$refs.stockTransactionModal.isSubmitting = false;
      } catch (error) {
        this.showToast("Failed to save transaction", "error");
        this.$refs.stockTransactionModal.isSubmitting = false;
      }
    },

    updateTransaction({transaction, stock}) {
      this.selectedStock = stock;
      this.selectedTransaction = transaction;
      this.transactionType = transaction.credit > 0 ? 0 : 1;
      if(this.transactionType === 0 && transaction.stockItemTransactionParentId > 0){
        let parentTransaction = this.ledgerTransactions.find(item => item.id == transaction.stockItemTransactionParentId);
        this.maxCredit = this.getTransactionBalances(parentTransaction) + transaction.credit;
      }
      
      this.modalTitle = "Update Transaction";
      this.$refs.stockTransactionModal.updateData(transaction);
      this.$bvModal.show("stock-transaction-modal");
    },

    deleteTransaction({transaction, stock}) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStockTransaction", transaction.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showStockLedger(stock);
              this.showToast("Transaction deleted successfully", "success");
            })
            .catch(() => {
              this.showToast("Failed to delete transaction", "error");
            });
        }
      });
    },

    async showStockLedger(stock) {
      this.ledgerStock = stock;
      this.ledgerLoading = true;
      this.$bvModal.show("stock-ledger-modal");
      
      try {
        const res = await this.$store.dispatch("stock/GetStockTransactions", stock.id);
        if (res.data.error) {
          this.showToast(res.data.errorMessage, "error");
          return;
        }
        this.ledgerTransactions = res.data;
      } catch (error) {
        this.showToast("Failed to load stock transactions", "error");
      } finally {
        this.ledgerLoading = false;
      }
    },

    toggleSelectAll() {
      this.selectAll = !this.selectAll;
      this.tableData.forEach(item => {
        item.selected = this.selectAll;
      });
    },

    onItemSelect() {
      if (this.selectedItems.length === this.tableData.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },

    formatNumber(value) {
      if (!value && value !== 0) return '0.00';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    ExcelDateToJSDate(serial) {
      var utc_days  = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;                                        
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    },
    downloadExcelTemplate(type) {
      const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
      };
      this.$swal({
        title: "Are you sure?",
        text: "You want to download the template?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, download it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          let wb = XLSX.utils.book_new();
          wb.Props = {
            Title:
              type == "stock" ? "Stock Template" : "Stock Transaction Template",
            Subject: "For Uploading",
            Author: "GIAMS Website",
            CreatedDate: new Date()
          };
          wb.SheetNames.push("Sheet 1");
          let ws_data =
            type == "stock"
              ? [
                  [
                    "StockNumber",
                    "Name",
                    "FundClusterId",
                    "UnitId",
                    "ItemCategoryId",
                    "UnitCost",
                    "Description"
                  ]
                ]
              : type == "debit"
              ? [["DateTime", "PoNumber", "Debit", "UnitCost", "Description"]]
              : [
                  [
                    "DateTime",
                    "RisNumber",
                    "Credit",
                    "DeliveryUnitId",
                    "Description"
                  ]
                ];
          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Sheet 1"] = ws;

          let wbout = XLSX.write(wb, {
            bookType: "xlsx",
            type: "binary"
          });
          if (type == "stock") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Template.xlsx"
            );
          } else if (type == "debit") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Debit_Template.xlsx"
            );
          } else if (type == "credit") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Credit_Template.xlsx"
            );
          }
        }
      });
    },
    checkExcelStockLabel(row) {
      var labels = [
        "StockNumber",
        "Name",
        "UnitId",
        "ItemCategoryId",
        "FundClusterId",
        "Description",
        "UnitCost",
        "Balance"
      ];
      var error = row.filter((f) => !labels.includes(f));
      if (error.length > 0) return true;
      else return false;
    },
    checkExcelStockData(row) {
      var error = false;
      this.errorData = "";
      if (!row.StockNumber || row.StockNumber.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "StockNumber";
        } else {
          this.errorData = this.errorData
            .toString()
            .concat(", ", "StockNumber");
        }
        error = true;
      }
      if (!row.Name || row.Name.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "Name";
        } else {
          this.errorData = this.errorData.toString().concat(", ", "Name");
        }
        error = true;
      }
      if (!row.UnitId || row.UnitId.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "UnitId";
        } else {
          this.errorData = this.errorData.toString().concat(", ", "UnitId");
        }
        error = true;
      }
      if (!row.ItemCategoryId || row.ItemCategoryId.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "ItemCategoryId";
        } else {
          this.errorData = this.errorData
            .toString()
            .concat(", ", "ItemCategoryId");
        }
        error = true;
      }
      return error;
    },
    uploadExcel(type, stock, parent) {
      this.maxCredit = 0;
      if(type == 'debit'){
        this.selectedStock = stock ? stock : null;
        this.selectedTransaction = null;
        this.uploadType = type;
      }else if(type == 'credit'){
        this.selectedStock = stock ? stock : null;
        this.selectedTransaction = parent ? parent : null;
        this.maxCredit = this.getTransactionBalances(this.selectedTransaction);
        this.uploadType = type;
      }
      this.uploadType = type;
      this.$bvModal.show("modal-excel");
    },
    uploadNow(excelList) {
      if (this.uploadType == "stock") {
        this.uploadExcelStock(excelList);
      } else {
        this.uploadExcelTransaction(excelList);
      }
    },
    uploadExcelStock(excelList) {
      var errorLabel = false;
      var errorData = false;
      var errorRow = null;
      this.errorData = "";
      var uploadArray = [];
      if (excelList.length == 0) {
        this.showToast("No data to upload!", "warning");
        return;
      }
      try {
        excelList.forEach((item) => {
          if (errorLabel || errorData) return;
          errorLabel = this.checkExcelStockLabel(Object.keys(item));
          errorRow = item;
          errorData = this.checkExcelStockData(item);
          uploadArray.push({
            stockNumber: item.StockNumber
              ? item.StockNumber.toString().trim()
              : "Not Indicated",
            name: item.Name ? item.Name.toString().trim() : "Not Indicated",
            unitId: item.UnitId ? item.UnitId.toString().trim() : 0,
            itemCategoryId: item.ItemCategoryId
              ? item.ItemCategoryId.toString().trim()
              : 0,
            fundClusterId: item.FundClusterId
              ? item.FundClusterId.toString().trim()
              : 0,
            description: item.Description
              ? item.Description.toString().trim()
              : "",
            unitCost: item.UnitCost
              ? this.getExactAmt(item.UnitCost.toString().trim())
              : "0",
            balance: item.Balance
              ? this.getExactAmt(item.Balance.toString().trim())
              : "0",
          });
        });
        if (errorLabel || errorData) return;
        this.$store
          .dispatch("stock/UploadStockTransaction", {campusId: this.$store.state.data.selectedCampus.id, uploadArray})
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.changeCampus(this.$store.state.data.selectedCampus.id);
            this.$bvModal.hide("modal-excel");
            this.showToast("Successfully uploaded!", "success");
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Uploading excel data!",
              "error"
            );
          });
      } catch (error) {
        this.tableBusy = false;
        this.showPermanentToast(
          `"${this.errorData}" from the "${errorRow.__rowNum__}${
            errorRow.__rowNum__ == 1
              ? "st"
              : errorRow.__rowNum__ == 2
              ? "nd"
              : errorRow.__rowNum__ == 3
              ? "rd"
              : "th"
          } item" of the uploaded excel file is missing / does not match the proper format.`,
          "warning"
        );
      } finally {
        this.tableBusy = false;
        if (errorLabel) {
          this.showPermanentToast(
            `The "label" from the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        } else if (errorData) {
          this.showPermanentToast(
            `"${this.errorData}" from the "${errorRow.__rowNum__}${
              errorRow.__rowNum__ == 1
                ? "st"
                : errorRow.__rowNum__ == 2
                ? "nd"
                : errorRow.__rowNum__ == 3
                ? "rd"
                : "th"
            } item" of the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        }
      }
    },
    async uploadExcelTransaction(excelList) {
      var errorLabel = false;
      var errorData = false;
      var errorRow = null;
      this.errorData = "";
      var uploadArray = [];
      if (excelList.length == 0) {
        this.showToast("No data to upload!", "warning");
        return;
      }
      try {
        excelList.forEach((item) => {
          if (errorLabel || errorData) return;
          errorLabel = this.checkExcelTransactionLabel(Object.keys(item));
          errorRow = item;
          errorData = this.checkExcelTransactionData(item);
          if (this.uploadType == "debit") {
            uploadArray.push({
              stockItemId: this.selectedStock.id,
              iarItemId: 0,
              status: "POSTED",
              referenceNumber: item.PoNumber
                ? item.PoNumber.toString().trim()
                : "Not Indicated",
              debit: item.Debit ? item.Debit.toString().trim() : "0",
              dateTime: item.DateTime
                ? this.ExcelDateToJSDate(item.DateTime)
                : new Date(),
              credit: "0",
              stockItemTransactionParentId: 0,
              deliveryUnitId: 0,
              unitCost: item.UnitCost ? item.UnitCost.toString().trim() : "0",
              description: item.Description
                ? item.Description.toString().trim()
                : ""
            });
          } else if (this.uploadType == "credit") {
            uploadArray.push({
              stockItemId: this.selectedStock.id,
              dateTime: item.DateTime
                ? this.ExcelDateToJSDate(item.DateTime)
                : new Date(),
              iarItemId: 0,
              status: "POSTED",
              referenceNumber: item.RisNumber
                ? item.RisNumber.toString().trim()
                : "Not Indicated",
              debit: "0",
              credit: item.Credit ? item.Credit.toString().trim() : "0",
              stockItemTransactionParentId: this.selectedTransaction ? this.selectedTransaction.id : 0,
              deliveryUnitId: item.DeliveryUnitId
                ? item.DeliveryUnitId.toString().trim()
                : 0,
              unitCost: this.selectedTransaction
                ? this.selectedTransaction.unitCost
                : "0",
              description: item.Description
                ? item.Description.toString().trim()
                : ""
            });
          }
        });
        let totalCredit = uploadArray.reduce((sum, curr) => sum + parseFloat(curr.credit), 0);  
        if(totalCredit > this.maxCredit){
          this.showToast("The total credit from the uploaded file exceeds the remaining balance of the selected transaction.", "warning");
          return;
        }
        if (errorLabel || errorData) return;
        await this.$store
          .dispatch("stock/CreateMultipleStockTransaction", uploadArray)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.showStockLedger(this.selectedStock);
            this.$bvModal.hide("modal-excel");
            this.showToast("Successfully uploaded!", "success");
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Uploading excel data!",
              "error"
            );
          });
      } catch (error) {
        this.tableBusy = false;
        this.showPermanentToast(
          `"${this.errorData}" from the "${errorRow.__rowNum__}${
            errorRow.__rowNum__ == 1
              ? "st"
              : errorRow.__rowNum__ == 2
              ? "nd"
              : errorRow.__rowNum__ == 3
              ? "rd"
              : "th"
          } item" of the uploaded excel file is missing / does not match the proper format.`,
          "warning"
        );
      }
    },
    checkExcelTransactionLabel(row) {
      var labels =
        this.uploadType == "debit"
          ? ["DateTime", "PoNumber", "Debit", "UnitCost", "Description"]
          : [
              "DateTime",
              "RisNumber",
              "Credit",
              "DeliveryUnitId",
              "Description"
            ];
      var error = row.filter((f) => !labels.includes(f));
      console.log(error);
      if (error.length > 0) return true;
      else return false;
    },
    checkExcelTransactionData(row) {
      var error = false;
      this.errorData = "";
      if (this.uploadType == "debit") {
        if (!row.DateTime || row.DateTime.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "DateTime";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "DateTime");
          }
          error = true;
        }
        if (!row.PoNumber || row.PoNumber.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "PoNumber";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "PoNumber");
          }
          error = true;
        }
        if (!row.Debit || row.Debit.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "Debit";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "Debit");
          }
          error = true;
        }
        if (!row.UnitCost || row.UnitCost.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "UnitCost";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "UnitCost");
          }
          error = true;
        }
      } else if (this.uploadType == "credit") {
        if (!row.DateTime || row.DateTime.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "DateTime";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "DateTime");
          }
          error = true;
        }
        if (!row.RisNumber || row.RisNumber.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "RisNumber";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "RisNumber");
          }
          error = true;
        }
        if (!row.Credit || row.Credit.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "Credit";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "Credit");
          }
          error = true;
        }
        if (!row.DeliveryUnitId || row.DeliveryUnitId.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "DeliveryUnitId";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "DeliveryUnitId");
          }
          error = true;
        }
      }
      return error;
    },
    async printRis(stockItem) {
      var apiUrl = `api/Report/Inspection/RIS`;
      var routeVariables = [stockItem.id];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    printStockLedger(stock) {
      var apiUrl = `api/Report/Inspection/RIS`;
      var routeVariables = [stock.id];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },  
    addDebitTransaction(stock) {
      this.selectedStock = stock;
      this.selectedTransaction = null;
      this.transactionType = 1;
      
      this.modalTitle = "Add Transaction";
      this.$refs.stockTransactionModal.resetForm();
      this.$refs.stockTransactionModal.generateRISNumber();
      this.$bvModal.show("stock-transaction-modal");
    },
    getTransactionBalances(transaction) {
      let totalCredits = 0;
      this.ledgerTransactions.map(item => {
        if (item.stockItemTransactionParentId == transaction.id) {
          totalCredits += item.credit;
        }
      });
      return parseFloat(transaction.debit) - parseFloat(totalCredits);
    },
    addCreditTransaction({transaction, stock}) {
      this.selectedStock = stock;
      this.selectedTransaction = null;
      this.transactionType = 0;
      this.maxCredit = this.getTransactionBalances(transaction);
      if(this.maxCredit <= 0){
        return this.showToast("This transaction has no remaining balance for credit.", "warning");
      }
      
      this.modalTitle = "Add Transaction";
      this.$refs.stockTransactionModal.resetForm(transaction.id);
      this.$refs.stockTransactionModal.generateRISNumber();
      if (transaction) {
        this.$refs.stockTransactionModal.form.description = transaction.referenceNumber ? `Credit for ${transaction.referenceNumber}` : '';
        this.$refs.stockTransactionModal.form.debit = 0;
        this.$refs.stockTransactionModal.form.unitCost = transaction.unitCost;
      }
      this.$bvModal.show("stock-transaction-modal");
    },
  }
};
</script>

<template>
  <Layout @changeCampus="changeCampus($event.id)">
    <PageHeader :title="title" :items="items" />
    
    <b-modal
      id="stock-ledger-modal"
      :title="`Stock Ledger - ${ledgerStock ? ledgerStock.name : ''}`"
      size="xxl"
      hide-footer
    >
      <StockLedger
        v-if="ledgerStock"
        :stock="ledgerStock"
        :transactions="ledgerTransactions"
        :loading="ledgerLoading"
        @add-debit="addDebitTransaction"
        @add-credit="addCreditTransaction"
        @edit-transaction="updateTransaction"
        @delete-transaction="deleteTransaction"
        @upload-transaction="uploadExcel($event.type, $event.stock, $event.parent)"
        @download-template="downloadExcelTemplate($event)"
        @print-ris="printRis"
        @print-stock-card="printStockLedger"
      />
    </b-modal>
    <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="d-flex gap-2">
              <b-form-input
                v-model="filter"
                type="text"
                placeholder="Search stocks..."
                style="width: 300px;"
              ></b-form-input>
              <b-form-select
                class="form-select"
                v-model="perPage"
                :options="pageOptions"
                style="width: 80px;"
              ></b-form-select>
            </div>
          </div>
          <div class="col-md-6 text-end">
            <b-button
              variant="danger"
              @click="deleteSelectedItems"
              v-if="hasSelectedItems"
              class="me-2"
            >
              <i class="bx bx-trash align-middle me-1"></i>
              Delete Selected ({{ selectedItems.length }})
            </b-button>
            <b-button variant="primary" @click="addStock" class="me-2">
              <i class="bx bx-plus align-middle me-1"></i>
              Add Stock
            </b-button>
            <b-button variant="success" @click="uploadExcel('stock')" class="me-2">
              <i class="bx bx-upload align-middle me-1"></i>
              Upload Stocks
            </b-button>
            <b-button variant="info" @click="downloadExcelTemplate('stock')">
              <i class="bx bx-download align-middle me-1"></i>
              Download Template
            </b-button>
          </div>
        </div>
        
        <!-- Stock Table -->
        <div class="custom-table-responsive mb-0 mt-2">
          <b-table
            :items="filtered"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :busy="tableBusy"
            striped
            hover
            responsive
            show-empty
            empty-text="No stocks found"
          >
            <!-- Select All Checkbox -->
            <template #head(select)>
              <div class="form-check form-checkbox-outline form-check-success mb-0">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isAllSelected"
                  @change="toggleSelectAll"
                />
              </div>
            </template>
            <template #cell(select)="data">
              <div class="form-check form-checkbox-outline form-check-success mb-0">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="data.item.selected"
                  @change="onItemSelect"
                />
              </div>
            </template>
            <template #cell(stockNumber)="data">
              <div class="position-relative">
                <RawData :data="data.item" v-if="$store.state.decrypt.isAdmin()" />
                <a href="javascript:void(0);" class="text-primary hover-underline">{{data.value}}</a>
              </div>
            </template>
            <template #cell(name)="data">
              <div>
                {{data.value}}
                <small class="d-block"><i>{{data.item.description}}</i></small>
              </div>
            </template>
            <template #cell(unitCost)="data">
                {{formatCurrency(data.value)}}
            </template>
            <template #cell(available)="data">
              <h5 class="mb-0">
                {{data.value}}
              </h5>
            </template>

            <template #cell(actions)="data">
              <a href="javascript:void(0);" class="text-info me-1 font-size-20" @click="showStockLedger(data.item)" title="View Ledger">
                <i class="bx bx-book-open"></i>
              </a>
              <a href="javascript:void(0);" class="text-success me-1 font-size-20" @click="updateItem(data.item)" title="Update Item">
                <i class="bx bx-edit"></i>
              </a>
              <a href="javascript:void(0);" class="text-danger me-1 font-size-20" @click="deleteItem(data.item)" title="Delete Item">
                <i class="bx bx-trash"></i>
              </a>
            </template>
          </b-table>
        </div>

        <div class="row" v-if="rows > perPage">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <StockModal
      ref="stockModal"
      :modalTitle="modalTitle"
      :itemCategories="itemCategories"
      :units="units"
      @submit="submitStock"
    />
    <StockTransactionModal
      ref="stockTransactionModal"
      :modalTitle="modalTitle"
      :transactionType="transactionType"
      :maxCredit="maxCredit"
      :deliveryUnits="deliveryUnits"
      @submit="submitTransaction"
    />
    <PrintOptions ref="printOpt" />
    <UploadStock 
      @upload-excel="uploadNow" 
    />
  </Layout>
</template>
